/// <amd-module name="VSSUI/Components/Dropdown/DropdownExpandableTextField" />
import * as React from "react";
import { ExpandableTextField } from "VSSUI/ExpandableTextField";
import { IIconProps } from "VSSUI/Icon";
import * as Resources from "VSSUI/Resources.Dropdown";
import { TextFieldFocusTreatmentBehavior } from "VSSUI/TextField";
import { css } from "VSSUI/Util";
import { IDropdownExpandableTextFieldProps } from "./DropdownExpandable.Props";

export function DropdownExpandableTextField(props: IDropdownExpandableTextFieldProps) {
    const { editable, expandableRef, items, inputClassName, renderSelectedItems, selection, showPrefix = true, ...rest } = props;
    let prefixIconProps: IIconProps | undefined;
    let text: string | undefined;

    if (!editable) {
        text = props.placeholder;
        if (selection.selectedCount > 0) {
            text = renderSelectedItems(selection, items) as string;
        }
    }

    // If only a single item is selected and the item has an icon we will show it as a prefix icon.
    if (showPrefix && selection.selectedCount === 1) {
        prefixIconProps = items[selection.value[0].beginIndex]?.iconProps;
    }

    return (
        <ExpandableTextField
            ariaHasPopup="menu"
            ariaRoleDescription={!editable ? Resources.DropdownExpandableRoleDescription : undefined}
            autoComplete={editable}
            ariaAutoComplete={editable ? "list" : undefined}
            focusTreatment={editable ? TextFieldFocusTreatmentBehavior.all : TextFieldFocusTreatmentBehavior.keyboardOnly}
            inputType={!editable ? "button" : undefined}
            editable={editable}
            ref={expandableRef as React.RefObject<ExpandableTextField>}
            value={text}
            {...rest}
            className={css(props.className, "bolt-dropdown-expandable-text-field", rest.disabled && "disabled")}
            inputClassName={css(inputClassName, "bolt-dropdown-expandable-textfield-input text-ellipsis")}
            onClick={event => expandableRef.current && expandableRef.current.expand()}
            prefixIconProps={props.prefixIconProps || prefixIconProps}
            tooltipProps={{ text, overflowOnly: true, overflowDetected, ...props.tooltipProps }}
            required={props.required}
        />
    );
}

function overflowDetected(anchorElement: HTMLElement): boolean {
    const { wordBreak, whiteSpace } = anchorElement.style;
    const height = anchorElement.clientHeight;
    anchorElement.style.wordBreak = "break-all";
    anchorElement.style.whiteSpace = "normal";
    const heightChanged = height < anchorElement.clientHeight;
    anchorElement.style.wordBreak = wordBreak;
    anchorElement.style.whiteSpace = whiteSpace;
    return heightChanged;
}
